import React from 'react';
import { Modal } from 'Components/Modal';

import './giftCardInfoModal.css';

export const GiftCardInfoModal = ({ isOpen, onClose, src }) => {
  return (
    <Modal isShowing={isOpen} onClose={onClose} customClass="giftInfoModal">
      <div className="giftInfoModalWrapper">
        <img className="giftInfoModalImg" src={src} alt="giftImage" />
      </div>
    </Modal>
  );
};
